const hiddenPhone = () => {
    const hiddenPhoneNumber = document.querySelectorAll('.hidden-phone-number');
    const emailButton = document.querySelectorAll('.contact-send-email');

    if (!hiddenPhoneNumber) {
        return;
    }

    hiddenPhoneNumber.forEach(function(el) {
        el.addEventListener('mousedown', (e) => {
            el.classList.add('revealed');

            // TRACKING VIA GOOGLE TAG MANAGER
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'phone_revealed',
                    phone_number: el.querySelector('.phone-number')?.innerText || null
                });
            }
        });
    });

    emailButton.forEach(function(emb) {
        emb.addEventListener('mousedown', (e) => {

            // TRACKING VIA GOOGLE TAG MANAGER
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'email_click',
                    email_address: emb.getAttribute('href') || null
                });
            }
        });
    });
}

export default hiddenPhone;